export const generateKey = (pre) => {
  return `${pre}_${Date.now()}`;
};
